<script lang="ts">
	//UI
	import ComponentLoading from "../common/ComponentLoading.svelte";
	import { Card } from "@hitit/new_ui/src";
	//Utils
	import { formatKrwNumber } from "@hitit/hub/src/v7/utils";
	import { t } from "../../../stores";

	type TotalRevenueRef = {
		count: number;
		amount: number;
	};

	export let revenueRefs: { card: TotalRevenueRef; cash: TotalRevenueRef } = {
		card: { count: 0, amount: 0 },
		cash: { count: 0, amount: 0 },
	};
	export let loading = false;

</script>

<Card>
	<div class="container">
		{#if loading}
			<div class="revenue-wrapper loading">
				<div class="card-name-wrapper">
					<img id="cash" src="/img/icons/card.png" alt="" />
					<span class="card-name">{$t('hub.revenue.revenue_cash')}
						({$t('global.count_2')})</span>
				</div>
				<ComponentLoading />
			</div>
			<div class="seperate-bar" />
			<div class="revenue-wrapper loading">
				<div class="card-name-wrapper">
					<img id="card" src="/img/icons/cash.png" alt="" />
					<span class="card-name">{$t('hub.revenue.revenue_card')}
						({$t('global.count_2')})</span>
				</div>
				<ComponentLoading />
			</div>
		{:else}
			<div class="revenue-wrapper">
				<div class="card-name-wrapper">
					<img id="cash" src="/img/icons/card.png" alt="" />
					<span class="card-name">{$t('hub.revenue.revenue_cash')}
						({revenueRefs.cash.count}{$t('global.count_2')})</span>
				</div>
				<h2>{formatKrwNumber(revenueRefs.cash.amount)}{$t('global.KRW')}</h2>
			</div>
			<div class="seperate-bar" />
			<div class="revenue-wrapper">
				<div class="card-name-wrapper">
					<img id="card" src="/img/icons/cash.png" alt="" />
					<span class="card-name">{$t('hub.revenue.revenue_card')}
						({revenueRefs.card.count}{$t('global.count_2')})</span>
				</div>
				<h2>{formatKrwNumber(revenueRefs.card.amount)}{$t('global.KRW')}</h2>
			</div>
		{/if}
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";

	/* Mobile First */
	.container {
		display: flex;
		flex-direction: column;
		gap: 19.5px;
		width: 100%;
		height: 100%;
		height: 100%;
		justify-content: space-between;
		word-break: break-all;

		.revenue-wrapper {
			display: flex;
			flex-direction: column;
			gap: 10px;
			width: 100%;

			&.loading {
				position: relative;
			}

			.card-name-wrapper {
				display: flex;
				gap: 10.5px;
				font-weight: 550;
				color: #6d6f76;
				align-items: flex-end;

				img {
					height: 30px;

					&#cash {
						width: 58.2px;
					}

					&#card {
						width: 42.2px;
					}
				}
			}

			h2 {
				font-weight: 600;
				font-size: 2.125rem;
				color: #46474b;
			}
		}
		.seperate-bar {
			width: 100%;
			height: 1px;
			background-color: #e6e7ec;
		}
	}

	@include DesktopSize {
		.container {
			min-height: 170px;
			flex-direction: row-reverse;
			.seperate-bar {
				width: 2px;
				height: 100%;
				background-color: #e6e7ec;
			}
			.revenue-wrapper {
				gap: 20px;
				min-height: 134px;
				.card-name-wrapper {
					gap: 9.5px;

					.card-name {
						font-size: 1.125rem;
					}

					img {
						height: 40px;
						object-fit: contain;

						&#cash {
							width: 77.5px;
						}

						&#card {
							width: 56.3px;
						}
					}
				}

				h2 {
					font-size: 2.5rem;
				}
			}
		}
	}

</style>
